// extracted by mini-css-extract-plugin
module.exports = {"root":"Dashboard_root__1EJPA","dashboardCards":"Dashboard_dashboardCards__1MHFa"};